var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "layout-footer mt-30" }, [
    _c("div", { staticClass: "footer-container fc99" }, [
      _c("div", { staticClass: "def-w f-b-c" }, [
        _c("div", { staticClass: "row" }, [
          _c("dl", [
            _c("dt", [_vm._v("联系我们")]),
            _c("dd", [_vm._v("联系电话：" + _vm._s(_vm.site.consultHotline))]),
            _c("dd", [_vm._v("地址：" + _vm._s(_vm.site.address) + " ")]),
          ]),
          _c("dl", [
            _c("dt", [_vm._v("技术支持")]),
            _c("dd", [_vm._v("技术支持：江苏易交易信息科技有限公司")]),
            _c("dd", [_vm._v("电话：" + _vm._s(_vm.site.technicalHotline))]),
            _c("dd", [
              _vm._v(
                "地址：江苏省常州市钟楼区玉龙南路280号常州大数据产业园4号楼21层"
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "wx-qrcode" }, [
          _c("img", {
            attrs: { src: _vm.site.wechatLogo, alt: _vm.site.name },
          }),
          _c("p", [_vm._v("关注微信公众号")]),
        ]),
      ]),
    ]),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "site-info fc99 bgff flex-column-center" },
      [
        _c("p", [
          _vm._v(
            " Copyright 2021 All Rights Reserved 长沙联合产权交易所阳光采购平台 版权所有 湘ICP备19019540号 "
          ),
        ]),
        _c("p", [
          _vm._v(
            " 地址：湖南省长沙市芙蓉区马王堆中路248号 技术支持：长沙市网络传媒有限公司 "
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }